import { render, staticRenderFns } from "./DeliverablesEditableList.view.vue?vue&type=template&id=79b805fc&"
import script from "./DeliverablesEditableList.view.vue?vue&type=script&lang=js&"
export * from "./DeliverablesEditableList.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b805fc')) {
      api.createRecord('79b805fc', component.options)
    } else {
      api.reload('79b805fc', component.options)
    }
    module.hot.accept("./DeliverablesEditableList.view.vue?vue&type=template&id=79b805fc&", function () {
      api.rerender('79b805fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/common/partials/deliverables/update/DeliverablesEditableList.view.vue"
export default component.exports